var React = require('react');

function CrossedOutHeart (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1.37204 0.928711L13.628 13.1854L12.6854 14.128L10.1874 11.63L7.50004 14.3234L1.84671 8.66204C0.486711 7.13938 0.494711 4.82671 1.86938 3.31338L0.428711 1.87204L1.37204 0.928711ZM12.9954 3.17138C14.5034 4.68338 14.5554 7.09138 13.1527 8.66204L12.0627 9.75271L4.34004 2.03071C5.45338 1.89271 6.61204 2.22271 7.50071 3.01938C9.06671 1.61338 11.4867 1.66004 12.9954 3.17138Z","fill":"#6B7580"}));
}

CrossedOutHeart.defaultProps = {"width":"15","height":"15","viewBox":"0 0 15 15","fill":"none"};

module.exports = CrossedOutHeart;

CrossedOutHeart.default = CrossedOutHeart;
